<nav class="h-100">
  <ul class="d-flex h-100">
    @for (item of navigationItems; track $index) {
      @if (!(role() === 'USER' && item.requiresAdmin)) {
        <li matRipple [matRippleTrigger]="trigger">
          <a
            class="h-100"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="hasCustomerProfile() ? item.link : null"
            [ariaDisabled]="!hasCustomerProfile()"
            #trigger
          >
            @if (item.icon.type === 'mat') {
              <mat-icon>{{ item.icon.name }}</mat-icon>
            } @else if (item.icon.type === 'fa') {
              <fa-icon [icon]="item.icon.name" />
            }
            <span class="pb-2">{{ item.label }}</span>
          </a>
        </li>
      }
    }
  </ul>
</nav>
